<script>
    import Common from "../common/index";

    export default {
        name: "tupian",
        mixins: [Common],
        watch: {
            show:{
                handler(vl) {
                    if (vl) {
                        this.init()
                    }
                },
                deep: true,
                immediate: true
            }
        },
        data(){
            return {
                type: 'image',
                config: [
                    {
                        type: 'SearchBox',
                        value: '',
                        fixed: true
                    },
                    {
                        type: 'UploadBtn',
                        value: '',
                        fixed: true
                    },
                    {
                        type: 'TypeBtn',
                        value: '',
                        selected: '2',
                        fixed: true
                    },
                    {
                        type: 'CatalogType',
                        value: '',
                        selected: '',
                        fixed: true
                    },
                    {
                        type: 'TypeList',
                        form: [
                            // {
                            //     title: '图片效果1',
                            //     data: [
                            //         // {url: this.$images.contents.datu, love: false},
                            //         // {url: this.$images.contents.datu, love: true},
                            //         // {url: this.$images.contents.datu, love: false},
                            //         // {url: this.$images.contents.datu, love: false},
                            //         // {url: this.$images.contents.datu, love: false},
                            //         // {url: this.$images.contents.datu, love: false},
                            //     ],
                            //     column: 2,
                            // },
                            // {
                            //     title: '图片效果2',
                            //     data: [
                            //         {url: this.$images.contents.datu, love: false},
                            //         {url: this.$images.contents.datu, love: true},
                            //         {url: this.$images.contents.datu, love: false},
                            //         {url: this.$images.contents.datu, love: false},
                            //         {url: this.$images.contents.datu, love: false},
                            //         {url: this.$images.contents.datu, love: false},
                            //     ],
                            //     column: 2,
                            // },
                        ],
                        selected: [],
                        isBackground: true
                    },
                    {
                        type: 'SearchList',
                        value: ''
                    },
                    {
                        type: 'MoreBtn',
                        value: ''
                    },
                ]
            }
        },
        methods:{
            onSearchBox(search){
                this.search = search
                // this.flashData()
            }
        }
    }
</script>
